import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOnOutlined,
  HomeOutlined,
  InventoryOutlined,
  CalendarTodayOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetWarehouseAllocationDetailQuery } from "store/services/warehouseAllocationApi";

const WarehouseAllocationInfoScreen = ({ allocationId }) => {
  const breadcrumbs = [
    {
      title: "Warehouse Allocation Info",
    },
  ];

  // RTK Query
  const {
    data: allocationDetail,
    isLoading: loadingAllocationDetail,
    error,
  } = useGetWarehouseAllocationDetailQuery(allocationId);

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingAllocationDetail}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingAllocationDetail ? (
          <Box padding={3}>
            <Typography variant="h6">
              {allocationDetail?.warehouse_name}
            </Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HomeOutlined color="primary" />}
                  title="Allocation ID"
                  subtitle={allocationDetail?.allocation_id}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Warehouse Location"
                  subtitle={allocationDetail?.warehouse_location}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Allocated Items"
                  subtitle={allocationDetail?.allocated_items}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Allocation Date"
                  subtitle={allocationDetail?.allocation_date}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Total Capacity"
                  subtitle={`${allocationDetail?.total_capacity} units`}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <InventoryOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={allocationDetail?.status === "active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseAllocationInfoScreen;
